export default function isEmptyArray (input) {
    if (!Array.isArray(input)) return false
    const filtered = input.filter(Boolean)
    return filtered.length === 0
}